import React from "react";
import { Badge, Card } from "react-bootstrap";
import { CardContent, Divider } from "@material-ui/core";
import {
  Apartment,
  CreditCard,
  Description,
  People,
  Person,
} from "@material-ui/icons";

/**
 * Componente para mostrar los campos amarillos extraídos en una tabla limpia.
 * @param {{ data: object }} props
 */
const FieldsTable = ({ jsonData }) => {
  // Función para convertir objeto a array de DataItems
  const objectToDataItems = (obj) => {
    return Object.entries(obj).map(([key, value]) => ({
      key: key
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase()),
      value: String(value),
      type: "primary",
    }));
  };

  // Procesar los datos JSON en secciones
  const sections = [
    {
      title: "Provider Information",
      color: "#007bff",
      bgColor: "rgb(239 246 255)",
      borderColor: "rgb(191 219 254)",
      data: objectToDataItems(jsonData.provider),
      isEmpty: Object.keys(jsonData.provider).length === 0,
    },
    {
      title: "Subscriber Details",
      color: "#007bff",
      bgColor: "rgb(239 246 255)",
      borderColor: "rgb(191 219 254)",
      data: objectToDataItems(jsonData.subscriber),
      isEmpty: Object.keys(jsonData.subscriber).length === 0,
    },
    {
      title: "Dependents",
      color: "#007bff",
      bgColor: "rgb(239 246 255)",
      borderColor: "rgb(191 219 254)",
      data:
        jsonData.dependents.length > 0
          ? jsonData.dependents.map((dep, index) => ({
              key: `Dependent ${index + 1}`,
              value:
                typeof dep === "object" ? JSON.stringify(dep) : String(dep),
              type: "secondary",
            }))
          : [],
      isEmpty: jsonData.dependents.length === 0,
    },
    {
      title: "Payer Information",
      color: "#007bff",
      bgColor: "rgb(239 246 255)",
      borderColor: "rgb(191 219 254)",
      data: objectToDataItems(jsonData.payer),
      isEmpty: Object.keys(jsonData.payer).length === 0,
    },
    {
      title: "Plan Status",
      color: "#007bff",
      bgColor: "rgb(239 246 255)",
      borderColor: "rgb(191 219 254)",
      data: objectToDataItems(jsonData.planStatus),
      isEmpty: Object.keys(jsonData.planStatus).length === 0,
    },
  ];

  const getValueStyle = (type) => {
    switch (type) {
      case "primary":
        return { color: "oklch(21% 0.034 264.665)", fontWeight: 500 };
      case "secondary":
        return { color: "oklch(37.3% 0.034 259.733)", fontWeight: 400 };
      case "accent":
        return {
          color: "#007bff",
          fontWeight: 500,
          paddingLeft: "0.75rem",
          paddingRight: "0.75rem",
          backgroundColor: "rgb(239 246 255)",
          paddingTop: "0.25rem",
          paddingBottom: "0.25rem",
          borderRadius: "calc(infinity * 1px)",
          fontSize: "14px",
          lineHeight: "1rem",
        };
      default:
        return { color: "oklch(27.8% 0.033 256.848)", fontWeight: 400 };
    }
  };

  return (
    <div
      className=" bg-gradient-to-br from-slate-50 to-slate-100 p-6"
      style={{ marginBottom: "2rem" }}
    >
      <div className="max-w-4xl mx-auto">
        <Card className="shadow-xl border-0 overflow-hidden">
          <CardContent className="p-0">
            <div className="divide-y divide-gray-100">
              {sections.map((section, sectionIndex) => (
                <div key={sectionIndex}>
                  {/* Section Header */}
                  <div
                    className="card-header"
                    style={{ borderLeft: `4px solid ${section.borderColor}` }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="flex-1">
                        <h5
                          className={`font-semibold m-0`}
                          style={{ color: section.color, fontSize: "1rem" }}
                        >
                          {section.title}
                        </h5>
                      </div>
                    </div>
                  </div>

                  {/* Section Data */}
                  {section.isEmpty ? (
                    <div className="empty-data">
                      <p className="empty-data-label m-0">
                        No information available for this section
                      </p>
                    </div>
                  ) : (
                    <div className="space-y-3 ml-4">
                      {section.data.map((item, itemIndex) => (
                        <div key={itemIndex} className="item-information">
                          <div className="flex-1 min-w-0">
                            <div className="item-information-text">
                              <span className="item-information-label">
                                {item.key}:
                              </span>
                              <div
                                className="item-information-value"
                                style={getValueStyle(item.type)}
                              >
                                {item.value}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {sectionIndex < sections.length - 1 && (
                    <Divider className="mt-6 bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
                  )}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default FieldsTable;
